import { ReactElement } from 'react'
import { BackButton, Loader, PageWrapper } from '../../../../components'
import { useHistory } from 'react-router-dom'
import { CardWrapper } from '../subcomponents'
import { FlexWrapper, Column } from '../../../../components'
import strings from '../../../../locale/en'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { Branch } from '../../../../redux/coachingCenter/types'
import { resetBranch } from '../../../../redux/coachingCenter/actions'

const BranchDetail = (): ReactElement => {
  const { isLoading, branch } = useSelector(
    (state: RootState) => ({
      isLoading: state.coachingCenter.isLoading,
      branch: state.coachingCenter.selectedBranch as Branch
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const history = useHistory()
  const {
    branchDetails: {
      branchName,
      address1,
      address2,
      country,
      state,
      city,
      zipcode,
      mobileNumber,
      email,
      mainBranch,
      questionLimit,
      availableCourses,
      status
    }
  } = strings

  return isLoading ? (
    <Loader />
  ) : (
    <PageWrapper id="container">
      <div>
        <BackButton
          handleBack={() => {
            dispatch(resetBranch())
            history.goBack()
          }}
        />
      </div>
      <FlexWrapper justifyContent="space-around">
        <CardWrapper>
          <Column keyName={branchName} value={branch?.branchName} />
          <Column keyName={address1} value={branch?.address1} />
          <Column keyName={address2} value={branch?.address2} />
          <Column keyName={country} value={branch?.country} />
          <Column keyName={state} value={branch?.state} />
          <Column keyName={city} value={branch?.city} />
          <Column keyName={zipcode} value={branch?.zipCode} />
        </CardWrapper>
        <CardWrapper>
          <Column keyName={mobileNumber} value={branch?.mobileNumber} />
          <Column keyName={email} value={branch?.email} />
          <Column keyName={mainBranch} value={branch?.isMainBranch} />
          <Column keyName={questionLimit} value={branch?.questionLimit} />
          <Column keyName={availableCourses}>
            <ul>
              {branch?.courseList?.map(({ courseName, id }) => (
                <li key={id}>{courseName}</li>
              ))}
            </ul>
          </Column>
          <Column keyName={status} value={branch?.status} />
        </CardWrapper>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default BranchDetail
